/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Subject_Chemistry16Inputs */

const en__field_enum_subject_chemistry16 = /** @type {(inputs: _Field_Enum_Subject_Chemistry16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chemistry`)
};

const de__field_enum_subject_chemistry16 = /** @type {(inputs: _Field_Enum_Subject_Chemistry16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chemie`)
};

/**
* | output |
* | --- |
* | "Chemistry" |
*
* @param {_Field_Enum_Subject_Chemistry16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_subject_chemistry16 = /** @type {((inputs?: _Field_Enum_Subject_Chemistry16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Subject_Chemistry16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_subject_chemistry16(inputs)
	return de__field_enum_subject_chemistry16(inputs)
});
export { _field_enum_subject_chemistry16 as "_field_enum_SUBJECT_CHEMISTRY" }